import 'styles/style.scss';

/*
* External dependencies.
*/
import React from 'react';
import ReactDOM from 'react-dom';

/*
* Internal dependencies.
*/
import App from './app';

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root')
);
